import script from "./FormularioIndicador.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormularioIndicador.vue?vue&type=script&lang=ts&setup=true"

import "./FormularioIndicador.vue?vue&type=style&index=0&id=3e4e59c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e4e59c4"]])

export default __exports__